import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
  numberFormat,
  refreshPage,
  toastStyle,
  getTodayDate,
  getType,
  selectDropdownStyle,
  getBranchId,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";

import {
  searchOrderByBranch,
  deleteOrder,
} from "../../../Helpers/apiCalls/Reports/DailyOrdersApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import Footer from "../../../Components/Footer/Footer";

export default function DailyOrders() {
  let navigate = useNavigate();
  const accountType = getType();
  const [inactive, setInactive] = useState(true);
  const [filterConfig, setFilterConfig] = useState({
    tab: "mango",
    group_orders: "true",
    group_by_date: "1",
    branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
  });
  const [showLoader, setShowLoader] = useState(false);
  const [sales, setSales] = useState([]);
  const [branches, setBranches] = useState([]);
  const [totalSales, settotalSales] = useState("");
  const [totalStoreSales, settotalStoreSales] = useState("");
  const [totalFoodpandaSales, settotalFoodpandaSales] = useState("");
  const [totalGrabSales, settotalGrabSales] = useState("");
  const [isClicked, setIsClicked] = useState(false);

  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const today = Moment().format("MM/DD/YYYY");


  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return { ...prev, [name]: value };
    });
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row);

    if (e.target.value === "view") {
      navigate(
        "/dailyorders/branch/" +
          row.branch_id +
          "/" +
          row.price_level +
          "/" +
          row.added_on,
        {
          state: {
            branch_id: row.branch_id,
            date: row.added_on,
            date_from: filterConfig.date_from ? filterConfig.date_from : today,
            date_to: filterConfig.date_to ? filterConfig.date_to : today,
          },
        }
      );
    } else if (e.target.value === "delete") {
      handleShowDeleteModal();
    }
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
      >
        <option value="" hidden selected>
          Select
        </option>
        {accountType === "admin" ? (
          <option value="view" className="color-options">
            View
          </option>
        ) : null}
        {accountType === "admin" ? (
          <option value="delete" className="color-red">
            Delete
          </option>
        ) : null}
      </Form.Select>
    );
  }

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={() => handleView(row)}
      >
        View
      </button>
    );
  }
  function handleView(row) {
    navigate(
      "/dailyorders/branch/" +
        row.branch_id +
        "/" +
        row.price_level +
        "/" +
        row.added_on,
      {
        state: {
          branch_id: row.branch_id,
          date: row.added_on,
          date_from: filterConfig.date_from ? filterConfig.date_from : today,
          date_to: filterConfig.date_to ? filterConfig.date_to : today,
        },
      }
    );
  }

  const handleTabSelect = (tabKey) => {
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        branch_id: "",
        date_from: "",
        date_to: "",
      };
    });
  };

  async function fetchBranches() {
    setShowLoader(true);
    setBranches([]);

    const response = await getAllBranches();
    if (response.data) {
      var allBranches = response.data.data.data
        .filter((branch) => {
          return branch.is_franchise === "0";
        })
        .map((data) => {
          var branch = data;
          branch.label = data.name;
          branch.value = data.id;
          return branch;
        });
      if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
          var filteredBranch = allBranches.filter((data) => {
          return data.id === getBranchId()
          })
          setBranches(filteredBranch);
      } else {
          setBranches([{label: "All Branches", value:""}, ...allBranches]);
      }
    }
    setShowLoader(false);
  }

  async function fetchData() {
    setShowLoader(true);
    setSales([]);

    const response = await searchOrderByBranch(filterConfig);
    if (response.error) {
      settotalSales("0");
      settotalStoreSales("0");
      settotalFoodpandaSales("0");
      settotalGrabSales("0");
    } else {
      var allBills = response.data.data.map((bill) => {
        var info = bill;
        info.added_on = Moment(bill.added_on).format("MM-DD-YYYY");
        info.store_sales = bill.store_sales
          ? numberFormat(bill.store_sales)
          : "";
        info.foodpanda_sales = bill.foodpanda_sales
          ? numberFormat(bill.foodpanda_sales)
          : "";
        info.grabfood_sales = bill.grabfood_sales
          ? numberFormat(bill.grabfood_sales)
          : "";
        info.grand_total = numberFormat(bill.grand_total);
        return info;
      });
      setSales(allBills);

      var total = response.data.summary
        ? response.data.summary.total_sales
        : "0";
      var totalstoresales = response.data.summary
        ? response.data.summary.total_store_sales
          ? response.data.summary.total_store_sales
          : "0"
        : "0";
      var totalfoodpanda = response.data.summary
        ? response.data.summary.total_foodpanda_sales
          ? response.data.summary.total_foodpanda_sales
          : "0"
        : "0";
      var totalgrab = response.data.summary
        ? response.data.summary.total_grabfood_sales
          ? response.data.summary.total_grabfood_sales
          : "0"
        : "0";
      settotalSales(total);
      settotalStoreSales(totalstoresales);
      settotalFoodpandaSales(totalfoodpanda);
      settotalGrabSales(totalgrab);
    }
    setShowLoader(false);
  }

  async function handleDeleteOrder() {
    setIsClicked(true);

    const response = await deleteOrder(selectedRow.id);
    if (response.data) {
      toast.success("Expense Deleted Successfully!", {
        style: toastStyle(),
      });
      setTimeout(() => refreshPage(), 1000);
    } else {
      toast.error("Error Deleting Expense", {
        style: toastStyle(),
      });
    }
  }

  useEffect(() => {
    fetchBranches();
  }, [filterConfig.tab]);

  useEffect(() => {
    fetchData();
  }, [filterConfig]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"DS REPORTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={9}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> DAILY ORDERS </h1>
          </Col>
          <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                  type="search"
                  name="branch_name"
                  placeholder="Search branch name"
                  className="search-bar"
                  onChange={handleOnSearch}
              />
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
            <Select
              className="dropsearch-filter"
              classNamePrefix="react-select"
              placeholder="Select Branch"
              styles={selectDropdownStyle}
              options={branches}
              onChange={(e) => {
                setFilterConfig((prev) => {
                  return { ...prev, branch_id: e.value };
                });
              }}
            />
            </Col>
            <Col xs={6} lg={2}>
            <DatePicker
              autoComplete="off"
              selected={filterConfig.date_from}
              name="date_from"
              placeholderText={today}
              onChange={(date) => {
                setFilterConfig((prev) => {
                  return { ...prev, date_from: date };
                });
              }}
              fixedHeight
              className="date-filter me-4 form-control"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
            </Col>
            <Col xs={6} lg={2}>
            <DatePicker
              autoComplete="off"
              selected={filterConfig.date_to}
              name="date_to"
              placeholderText={today}
              onChange={(date) => {
                setFilterConfig((prev) => {
                  return { ...prev, date_to: date };
                });
              }}
              fixedHeight
              className="date-filter ps-label-content me-5 form-control"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
            </Col>
          </Row>
          <div className="mb-2" />

          <div className="my-2 px-2 PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 align-middle mt-2 ps-label">
              Total Sales: {numberFormat(totalSales)}
            </span>
            <span className="me-4 ml-4 align-middle mt-2 ps-label">
              Total Store Sales: {numberFormat(totalStoreSales)}
            </span>
            <span className="me-4 ml-4 align-middle mt-2 ps-label">
              Total Food Panda Sales: {numberFormat(totalFoodpandaSales)}
            </span>
            <span className="me-4 ml-4 align-middle mt-2 ps-label">
              Total Grab Food Sales: {numberFormat(totalGrabSales)}
            </span>
          </div>

          <div className="below">
            {/* table */}
            <Table
              tableHeaders={[
                "-",
                "DATE",
                "BRANCH",
                "CASH SALES",
                "FOOD PANDA SALES",
                "GRAB FOOD SALES",
                "TOTAL SALES",
                "LAST SYNC",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "added_on",
                "branch_name",
                "store_sales",
                "foodpanda_sales",
                "grabfood_sales",
                "grand_total",
                "last_sync",
              ]}
              tableData={sales}
              ActionBtn={(row) => ActionBtn(row)}
              ViewBtn={(row) => ViewBtn(row)}
              showLoader={showLoader}
            />
          </div>
          <div className="mb-2" />
        </div>
      </div>

      {/* modals */}
      <Delete
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        text="order"
        onDelete={handleDeleteOrder}
        isClicked={isClicked}
      />
      <Footer/>
    </div>
  );
}
